//* 카운트다운·시각 표기용 짧은 헬퍼 (KST 고정 날짜 표기는 kstDate 유틸을 쓸 것)

/** 5 → "05" */
export const pad2 = (n: number): string => String(n).padStart(2, '0');

/** 지금부터 at 까지 남은 초 (지났으면 0). 인터셉터가 Date 로 바꿔 놓은 값도 그대로 받는다 */
export const secondsUntil = (at: Date | string): number =>
  Math.max(0, Math.floor((new Date(at).getTime() - Date.now()) / 1000));

/**
 * 초 → "m:ss" (예 65 → "1:05"). padMinutes 면 분도 두 자리 (예 "01:05").
 * ms 로 갖고 있으면 호출부에서 초로 바꿔 넘길 것.
 */
export const formatMmSs = (totalSec: number, padMinutes = false): string => {
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return `${padMinutes ? pad2(minutes) : minutes}:${pad2(seconds)}`;
};
